<section class="provider-profile">
  <div class="provider-header-with-bio">
    <div class="provider-header">
      @if (!noProfilePhoto) {
        <div class="image-container">
          <img 
            src="{{ providerShareableProfile().profile_photo_url }}" 
            alt="{{ providerShareableProfile().display_name }} licensed professional therapist in {{ locationStatesWithCertifications | stringArrayToCommaList }}"
            class="provider-image"
            fetchpriority="high"
            data-test="provider-image"
          >
        </div>
      } @else {
        <br/>
      }

      <div class="provider-header-details">
        <div class="names-and-pronouns-container">
          <h1 class="provider-name" data-test="provider-display-name">{{ providerShareableProfile().display_name }}</h1>
        </div>
        <p class="provider-credentials" data-test="provider-credentials">
          {{ providerType }} • <span class="provider-credential-abbreviations"> {{ certificationAbbreviations | stringArrayToCommaListNoConjunction }} </span>
          @if (providerShareableProfile()?.pronouns?.length > 0) {
            <span 
              class="provider-pronouns"
              data-test="provider-pronouns"
            >
              ({{ providerShareableProfile().pronouns }})
            </span>
          }
        </p>
        <div class="provider-licensed-states" data-test="provider-state">
          @for (state of locationStatesWithCertifications; track state; let last = $last) {
            <span (click)="navigateToProviderDirectory(state)" class="state-link">{{state}}</span>
            @if (!last) {
              <span>, </span>
            }
          }
        </div>
        
        <div class="type-and-insurance-container">
          <div class="provider-pills">
            <provider-pills
              [providerAcceptedInsuranceIds]="providerNetworkCompanyIds"
              [providerInsurances]="providerAcceptedInsuranceNames"
              [providerTopSpecialtiesIds]="topSpecialtiesIds"
              [providerSpecialties]="providerShareableProfile().specialties"
              [providerSessionTypesOffered]="providerShareableProfile().session_types_offered"
              [selectedInsuranceName]="queryParamMap().get('insuranceName')"
              [selectedInsurancePncId]="queryParamMap().get('pncId')"
              [selectedSpecialties]="queryParamSpecialties"
              [longSessionTypesDisplayText]="true"
            ></provider-pills>
          </div>
        </div>
      </div>
    </div>

    <div class="bio-specialty-details">
      @if (providerShareableProfile().mini_bio.length) {
        <div class="mini-bio-container" data-test="mini-bio-card">
          <iris-icon
            name="quote"
            colorToken="$color-dec-indigo-200"
          />
          <div class="mini-bio">
            {{ providerShareableProfile().mini_bio }} <span class="name-signoff"> – {{ providerShareableProfile().display_first_name }} </span>
          </div>
        </div>
      }

      @if (topSpecialties().length > 0) {
        <div 
          class="specializes-in"
          data-test="specialties-card"
        >
          <h3>
            <iris-icon
              name="stars"
              colorToken="$color-dec-kelly-100"
            />
            Specializes in
          </h3>
          <div class="specialties-list" data-test="specialties-list">
            @for (specialty of topSpecialties(); track specialty.id; let i = $index) {
              <div>
                <span [ngClass]="{'highlight': specialty.isQueryParam}">{{specialty.name}}</span> 
                <span>{{i < topSpecialties().length - 1 && topSpecialties().length > 2 ? ',  ' : ' '}}</span>
                <span>{{i == topSpecialties().length - 2 && topSpecialties().length > 1 ? 'and' : ''}}</span>
              </div>
            }
          </div>
          <button 
            id="show-more-specialties"
            class="show-specialties-list-button" 
            (click)="scrollToElement('specialties-section')"
            tabindex="0"
            data-test="show-more-specialties-button"
          >
            Show more
          </button>
        </div>
      }
    </div>
  </div>
</section>
